export default __webpack_public_path__ + "static/media/night-sky.716cf2ccd29d4a3d98751fa29872015c.svg";